/* global  */ // tUrl等のグローバル変数を宣言する

// import 'core-js/features/number/is-nan' // SwiperのIE対応
// import 'custom-event-polyfill' // SwiperのIE対応
import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,
$(function () {
  if (document.getElementsByClassName('js-in')[0]) {
    // 画面に入った監視対象に.animatedを付加
    // Intersection Observer
    intObs()
  }
  function intObs() {
    let rootMargin = '-10px 0px'
    if (window.matchMedia('(max-width:768px)').matches) {
      //SPは検出を早くする
      rootMargin = '100px 0px'
    }
    const intObsOption = {
      // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
      rootMargin: rootMargin, // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
      threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
    }
    const observer = new IntersectionObserver(intObsCallback, intObsOption)
    const intObsItems = document.getElementsByClassName('js-in')
    for (let index = 0; index < intObsItems.length; index++) {
      const intObsItem = intObsItems[index]
      observer.observe(intObsItem) // 監視対象に加える
    }
    function intObsCallback(entries) {
      for (let index = 0; index < entries.length; index++) {
        const entry = entries[index]
        if (entry.isIntersecting) {
          const entryItem = entry.target
          entryItem.classList.add('active')
          observer.unobserve(entryItem) // 監視対象から外す
        }
      }
    }
  }
})

function slideAnime() {
  //====左に動くアニメーションここから===
  $('.leftAnime').each(function () {
    var elemPos = $(this).offset().top - 50
    var scroll = $(window).scrollTop()
    var windowHeight = $(window).height()
    if (scroll >= elemPos - windowHeight) {
      //左から右へ表示するクラスを付与
      //テキスト要素を挟む親要素（左側）とテキスト要素を元位置でアニメーションをおこなう
      $(this).addClass('slideAnimeLeftRight') //要素を左枠外にへ移動しCSSアニメーションで左から元の位置に移動
      $(this).children('.leftAnimeInner').addClass('slideAnimeRightLeft') //子要素は親要素のアニメーションに影響されないように逆の指定をし元の位置をキープするアニメーションをおこなう
    } else {
      //左から右へ表示するクラスを取り除く
      $(this).removeClass('slideAnimeLeftRight')
      $(this).children('.leftAnimeInner').removeClass('slideAnimeRightLeft')
    }
  })
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
  slideAnime() /* アニメーション用の関数を呼ぶ*/
}) // ここまで画面をスクロールをしたら動かしたい場合の記述

// 画面が読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
  slideAnime() /* アニメーション用の関数を呼ぶ*/
}) // ここまで画面が読み込まれたらすぐに動かしたい場合の記述

$(function () {
    let thisSlideIndex = 0
  var topMvSlide = new Swiper('#topMvSlide', {
    effect: 'fade',
    loop: true,
    loopAdditionalSlides: 5,
    slidesPerView: 1,
    autoplay: {
      delay: 6000,
      disableOnInteraction: false,
    },
    // ページネーション
      pagination: {
        el: '.js-topMv-pagination',
        type: 'bullets',
        clickable: true,
      },
    on: {
      init: function () {
        let currentSlide = $('.swiper-slide-active')
        let Slide = $('.swiper-slide').not('.swiper-slide-active')
        currentSlide.find('.js-slide-caption').addClass('slide-in')
      },
      slideChangeTransitionStart: function () {
        let currentSlide = $('.swiper-slide-active')
        let Slide = $('.swiper-slide').not('.swiper-slide-active')
        currentSlide.find('.js-slide-caption').addClass('slide-in')
        Slide.find('.js-slide-caption').removeClass('slide-in')
      },
      transitionStart: function () {
        // スライドが切り替わった時
        thisSlideIndex =
          $('.js-topMv-pagination .swiper-pagination-bullet').index(
            $('.js-topMv-pagination .swiper-pagination-bullet-active')
          ) + 1
        $('.js-topMv-pagination-num .current').text(thisSlideIndex)
      },
    },
  })
})
$('.FAQ__Q').on('click', function () {
  $(this).toggleClass('active')
  $(this).next().slideToggle()
  $(this).children('i').toggleClass('open')
})
